module.exports = __webpack_public_path__ + "img/CX-banner-1-3.ade75366.png";